/**
 * Update Notice Block Renderer
 *
 * Display-only acknowledgement rows for draft field changes during guided
 * flows (create-routine): a pencil icon plus "Field verb value" per row, e.g.
 * "Routine title generated" or "Runs updated to Daily · 9:30 AM". Never
 * interactive — it renders identically live and from history.
 */

import { Pencil } from "lucide-react";
import type { UIBlock } from "@/types/ui-blocks";

export interface UpdateNoticeBlockRendererProps {
  block: UIBlock;
}

export function UpdateNoticeBlockRenderer({ block }: UpdateNoticeBlockRendererProps) {
  if (block.type !== "update_notice") return null;

  const updates = block.content.updates ?? [];
  if (updates.length === 0) return null;

  return (
    <div className="my-1 flex flex-col gap-2">
      {updates.map((update, index) => (
        <div
          key={`${update.field}-${index}`}
          className="flex items-center gap-2 text-xs text-gray-500"
        >
          <Pencil className="h-3.5 w-3.5 shrink-0 text-gray-400" aria-hidden="true" />
          <span className="font-medium text-gray-600">{update.field}</span>
          <span>{update.verb}</span>
          {update.value ? (
            <span className="truncate font-medium text-gray-600">{update.value}</span>
          ) : null}
        </div>
      ))}
    </div>
  );
}
